import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useVerificationMethodMutations } from '../../../hooks/useNomenclatures';

const VerificationMethodList = ({ items, onUpdate }) => {
  const mutations = useVerificationMethodMutations();

  const fields = [
    { name: 'requiresDevice', label: 'Requires Device', type: 'boolean' },
    { name: 'automated', label: 'Automated', type: 'boolean' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="verification-methods"
      title="Verification Methods"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default VerificationMethodList;

